import { TypeGuard } from '@principle-theorem/shared';
import { BehaviorSubject, Observable } from 'rxjs';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class AmendAccTransaction implements ITransactionAction<unknown> {
  icon = 'edit';
  label = 'Amend';
  tooltip = 'Amend this ACC transaction to match your remittance advice';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = TypeGuard.noGuard<unknown>();

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(data: ITransactionActionsData<unknown>): Observable<boolean> {
    return TransactionHelpers.canAmend$(data);
  }

  async do(data: ITransactionActionsData<unknown>): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.amend(
      data.invoice,
      data.latestTransaction,
      'Amend ACC Transaction'
    );
    this.inProgress$.next(false);
  }
}
